import {ChangeDetectorRef, Component, inject, OnInit} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {ActivatedRoute} from '@angular/router';
import {LoadingSpinner} from '../loading-spinner/loading-spinner';
import {Routing} from '../service/routing/routing';
import {LoaService} from '../service/loa/loa';
import {catchError, EMPTY} from "rxjs";
import {BrandDetails, Loa, SubmittedLoa} from "../models/Loa";
import {FormsModule} from '@angular/forms';
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {MatTableModule} from '@angular/material/table';
import {LoaSubmittedComponent} from '../loa-submitted/loa-submitted.component';
import {LoaForm} from '../loa-form/loa-form';
import {Footer} from '../footer/footer';

@Component({
  selector: 'app-loa-page',
  imports: [LoadingSpinner, FormsModule, FontAwesomeModule, MatTableModule, LoaSubmittedComponent, LoaForm, Footer],
  templateUrl: './loa-page.html',
  styleUrl: './loa-page.scss',
})
export class LoaPage implements OnInit {
  isLoading = true;
  public loaService = inject(LoaService);
  private route = inject(ActivatedRoute);
  private routing = inject(Routing);
  private document = inject(DOCUMENT);
  loa!: Loa | SubmittedLoa;
  brandDetails: BrandDetails | null = null;
  private cdr = inject(ChangeDetectorRef);

  token!: string;
  pdfFile: File | null = null;
  /**
   * `true` when every meter on the fetched LOA is a renewal. Captured here so the renewal
   * copy survives the swap to the submitted view, which has no meters of its own.
   */
  isRenewal = false;

  /**
   * Reads the submission token from the route, redirects to 404 if absent,
   * then fetches the LOA. On success, stores brand details and injects the
   * brand favicon into the document head. Redirects to 404 on API error.
   */
  ngOnInit(): void {
    const token = this.route.snapshot.paramMap.get('token');

    if (!token) {
      this.routing.goToNotFound();
      return;
    }

    this.token = token;
    this.loaService.getSubmissionLoa(token).pipe(
      catchError(error => {
        this.routing.goToNotFound();
        return EMPTY;
      })
    ).subscribe((data: Loa | SubmittedLoa) => {
      this.loa = data;
      if (!this.loaService.isSubmittedLoa(data)) {
        this.brandDetails = data.brandDetails;
        this.isRenewal = this.loaService.isRenewalLoa(data);
        if (data.brandDetails?.favicon) {
          const link: HTMLLinkElement = this.document.querySelector("link[rel='icon']") ?? this.document.createElement('link');
          link.rel = 'icon';
          link.href = data.brandDetails.favicon;
          this.document.head.appendChild(link);
        }
      }
      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }
}
